import { render, staticRenderFns } from "./ComposicaoAlimentoPadrao.vue?vue&type=template&id=8e2887d8&"
import script from "./ComposicaoAlimentoPadrao.vue?vue&type=script&lang=js&"
export * from "./ComposicaoAlimentoPadrao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports